<template>
  <v-container fluid>
    <PdfModal
      v-model="mostrarPdf"
      :title= this.titulo
      :file-name="`${this.titulo} ${this.idSelect}`"
      :fetch-document="obtenerPdf"
      :file-type="this.tipoDocumento"
    />
    <v-card outlined>
      <v-card-subtitle>
        Puedes <strong>buscar</strong> por número de membresía, nombre del titular, nombre del contratante, agente o
        colectividad.
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <!-- Campo de búsqueda -->
          <v-col cols="12" m="3" md="3" lg="3">
            <v-text-field clearable class="col" v-model="NombreMem" label="Titular / membresía / contratante" outlined
              dense @change="changeSearch" @keyup.enter="Buscar">
            </v-text-field>
          </v-col>
          <!-- Selector de agentes -->
          <v-col cols="12" m="2" md="3" lg="2">
            <list-agentes @agent-change="changeAgent"></list-agentes>
          </v-col>
          <!-- Selector de colectivos y botón de descarga -->
          <v-col cols="12" m="2" md="5" lg="4">
            <select-colectivos :colectivos="colectivos" @colectivo-change="changeColectividad">
            </select-colectivos> Detalles
          </v-col>
          <!-- Botón de búsqueda -->
          <v-col>
            <v-btn color="azulfuerte" @click="Buscar" dark>
              Buscar
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-show="verOptDownloadCole">
          <v-btn color="azul_med" @click="DescargaZip" dark small class="mt-2">
            Descargar tarjetas
          </v-btn>
          <v-col>
            <p><strong>ACTIVAS: </strong> {{ this.activas }} </p>
            <p v-for="plan in this.planesUnicos" :key="plan.nombre">
              <strong>{{ plan.nombre }}: </strong> {{ plan.cantidad }}
            </p>
            <p><strong>SUSPENDIDAS: </strong>{{ this.suspendidas }}</p>
            <p><strong>BAJAS: - </strong>{{ this.totalbajas }}</p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <tabla-membresias :membresias="this.contratos" :actions="tableActions"
      @action-selected="onActionSelected"></tabla-membresias>
    <pases-medicos-dialog v-show="dialogPases" ref="modalPaseMedico" :isOpen.sync="dialogPases"
      :item="this.MembresiaSelect" @crear-cita="CrearCita" @crear-cita-externa="CrearCitaExterna" :optPaseExt="true">
    </pases-medicos-dialog>
    <modal-list-pagos :isOpen.sync="dialogRecibos" :Membresia="this.MembresiaSelect.Id || ''"></modal-list-pagos>

    <v-dialog v-model="dialogBeneficiados" max-width="80%" persistent>
      <v-card>
        <v-card-title class="text-h6">Beneficiarios: {{ this.MembresiaSelect.Id }}</v-card-title>
        <v-card-text>
          <list-beneficiarios :membresia="this.MembresiaSelect?.Id || ''"></list-beneficiarios>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="dialogBeneficiados = false">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
<v-dialog v-model="dialogReembolso" max-width="1300px" persistent scrollable>
  <v-card class="rounded-lg">

    <!-- HEADER -->
    <v-card-title class="d-flex align-center">
      <div>
        <div class="text-h6 font-weight-bold">
          Registro de Reembolso
        </div>
        <div class="text-caption grey--text">
          Complete la información requerida
        </div>
      </div>

      <v-spacer />

      <v-btn icon @click="dialogReembolso = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider />

    <v-card-text class="pa-4">
      <v-row dense>

        <!-- COLUMNA IZQUIERDA: TABLA -->
        <v-col cols="12" md="7">
          <v-card outlined class="rounded-lg fill-height">
            <v-card-title class="py-3">
              <span class="text-subtitle-1 font-weight-bold">
                Reembolsos registrados
              </span>
            </v-card-title>

            <v-divider />

            <v-card-text class="pa-3">
              <tabla-reembolsos :id="MembresiaSelect.Id" :reload-trigger="reloadReembolsos" />
            </v-card-text>
          </v-card>
        </v-col>

        <!-- COLUMNA DERECHA: FORMULARIO -->
        <v-col cols="12" md="5">
          <v-card outlined class="rounded-lg fill-height">
            <v-card-title class="py-3">
              <span class="text-subtitle-1 font-weight-bold">
                Nuevo reembolso
              </span>
            </v-card-title>

            <v-divider />

            <!-- INFO MEMBRESÍA -->
            <v-card-text>
              <v-row dense>
                <v-col cols="12">
                  <strong>Membresía:</strong>
                  <div class="grey--text">
                    {{ MembresiaSelect.Id }}
                  </div>
                </v-col>

                <v-col cols="12">
                  <strong>Coberturas:</strong>
                  <show-coberturas-component :value="MembresiaSelect.Coberturas" />
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider />

            <!-- FORMULARIO -->
            <v-card-text>
              <v-form ref="formReembolso" v-model="formValido">
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="reembolso.Folio"
                      label="Folio de factura"
                      outlined
                      dense
                      clearable
                      required
                      :rules="[rules.ruleRequired]"
                    />
                  </v-col>

                  <v-col cols="12" md="6">
                    <SelectCatalogoTipoReembolsoComponent
                      v-model="reembolso.IdTipoReembolso"
                      @value-changed="changetipoRee"
                    />
                  </v-col>

                  <v-col cols="12" md="6">
                    <select-beneficiados-membresia
                      :membresia="MembresiaSelect.Id"
                      @value-changed="updateBen"
                    />
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-menu
                      ref="menuFecha"
                      v-model="menuFecha"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="reembolso.FechaGasto"
                          label="Fecha del gasto"
                          outlined
                          dense
                          readonly
                          required
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>

                      <v-date-picker
                        v-model="reembolso.FechaGasto"
                        :max="fechaHoy"
                        @input="menuFecha = false"
                      />
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="reembolso.Monto"
                      label="Monto"
                      outlined
                      dense
                      prefix="$"
                      type="number"
                      required
                      :rules="[
                        v => !!v || 'El monto es obligatorio',
                        v => Number(v) > 0 || 'El monto debe ser mayor a 0',
                        v => Number(v) <= maxUrgencia || `Máximo permitido $${maxUrgencia}`
                      ]"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider />

            <v-card-actions class="px-4 py-4">
              <v-spacer />

              <v-btn text color="grey" @click="dialogReembolso = false">
                Cerrar
              </v-btn>

              <v-btn
                color="primary"
                :disabled="!formValido"
                @click="guardarReembolso"
              >
                 {{ loading ? 'Guardando...' : 'Guardar' }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

      </v-row>
    </v-card-text>
  </v-card>
</v-dialog>
  </v-container>
</template>
<script>
import SelectBeneficiadosMembresia from '@/components/selectBeneficiadosMembresia.vue';
import SelectCatalogoTipoReembolsoComponent from '@/components/selectCatalogoTipoReembolsoComponent.vue';
import ShowCoberturasComponent from '@/components/showCoberturasComponent.vue';
import PdfModal from "@/components/PdfModalComponent.vue";
import TablaReembolsos from '@/components/tablaReembolsosbyMembresia.vue'
export default {
  computed: {
    mem() {
      return this.$route.params.mem;
    },
    maxUrgencia() {
      return Number(this.MembresiaSelect.MontoUrgencias) || 0
    },
    fechaHoy() {
      return new Date().toISOString().substr(0, 10)
    },
    rules() {
      return this.$rules;
    }
  },
  components: {
    SelectColectivos: () => import('@/components/selectColectivo.vue'),
    ListAgentes: () => import('@/components/selectAgenteComponent.vue'),
    TablaMembresias: () => import('@/components/tableMembresias.vue'),
    ListBeneficiarios: () => import('@/components/tableBeneficiados.vue'),
    PasesMedicosDialog: () => import('@/components/modals/PasesMedicosDialog.vue'),
    ModalListPagos: () => import('@/components/modals/ListPagoComponent.vue'),
    SelectCatalogoTipoReembolsoComponent,
    SelectBeneficiadosMembresia,
    ShowCoberturasComponent,
    PdfModal,
    TablaReembolsos
  },
  mounted() {
    this.NombreMem = this.$route.params.mem || null;
    if (this.NombreMem) {
      this.getMembresias()
    }
    this.getColectivos()
  },
  data() {
    return {
      reloadReembolsos: 0,
      loading: false,
      titulo: null,
      tipoDocumento: 'pdf',
      idSelect: null,
      mostrarPdf: false,
      planesUnicos: {},
      activas: 0,
      suspendidas: 0,
      totalbajas: 0,
      colectivos: [],

      dialogBeneficiados: false,
      dialogPagoShow: false,
      dialogPases: false,
      dialogRecibos: false,
      dialogReembolso: false,

      isModalCitas: false,

      MembresiaSelect: {},

      NombreMem: null,
      verOptDownloadCole: false,
      contratos: [],
      idagenteSelect: null,
      idcolectividadSelect: null,
      tableActions: [
        'BENEFICIADOS',
        'HISTORIAL RECIBOS',
        'PASES MEDICOS',
        'TARJETA DIGITAL',
        'REEMBOLSOS',
        //'RENOVACION'
        // 'URGENCIAS',
        // 'CONTRATO'
      ],
      formValido: false,
      menuFecha: false,
      reembolso: {
        IdContrato : null,
        IdPaciente: '',
        IdTipoReembolso : 1,
        Monto: null,
        FechaGasto : null,
        Folio: null
      }
    }
  },
  methods: {
    async obtenerPdf(){
     return await  this.$http.get(`file/${this.idSelect}/TARJETA/pdf`,
        {
            responseType: 'blob'
        })
    },
    verTarjeta(){
      this.tipoDocumento = 'image'
      this.titulo = "Tarjeta digital"
      this.mostrarPdf = true
      
    },
    updateBen(value) {
      // Actualiza el beneficiario
      this.reembolso.IdPaciente = value.Id
    },
    CrearCitaExterna(cita, callback) {
      if (!cita.Paciente || !cita.Contrato || !cita.Especialidad || !cita.MedNombres || !cita.MedApaterno) {
        this.$swal.fire({
          // position: 'top-end',
          title: 'Infomación',
          text: `Ingresa los datos requeridos.`,
          icon: 'warning',
          confirmButtonText: 'Cerrar',
          showCloseButton: false,
          // timer: 1500,
          backdrop: false,
        })
      } else {

        this.$http.post(`membresia/citamedicaexterna`, cita)
          .then(response => {
            if (response.status === 200) {
              this.colectivos = response.data
              this.actualizaNumCitas(cita.Contrato)


              this.$swal.fire({
                position: 'top-end',
                title: 'Correcto',
                text: 'Su pase médico se genero correctamente',
                icon: 'success',
                confirmButtonText: 'Cerrar',
                showCloseButton: false,
                showConfirmButton: false,
                timer: 1500,
                backdrop: false
              })

              // Suponemos que result.id es el ID de la nueva cita
              const nuevoId = response.data; // result.id

              // Ejecutar callback para avisar al modal
              callback(nuevoId)
            } else {
              this.$swal.fire({
                title: 'Infomación',
                text: 'No tienes pases sificientes puedes hacer una recarga de 5 a un costo especial contacta a tu agente.',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
                backdrop: false
              });
            }
          })
          .catch(() => {

          })
          .finally(() => {
            // this.$refs.modalPaseMedico.reloadTable()
          });
      }
    },
    CrearCita(cita, callback) {
      if (cita.beneficiado && cita.especialidad && cita.medico.IdMedico && cita.membresia) {
        this.$http.post(`membresia/citamedica`, {
          idMem: cita.membresia,
          idEsp: cita.especialidad,
          idMed: cita.medico.IdMedico,
          idBen: cita.beneficiado
        })
          .then(response => {
            if (response.status === 200) {

              this.actualizaNumCitas(cita.membresia)
              this.$swal.fire({
                position: 'top-end',
                title: 'Correcto',
                text: 'Su pase médico se genero correctamente',
                icon: 'success',
                confirmButtonText: 'Cerrar',
                showCloseButton: false,
                showConfirmButton: false,
                timer: 1500,
                backdrop: false
              })
              // Suponemos que result.id es el ID de la nueva cita
              const nuevoId = response.data; // result.id
              // Ejecutar callback para avisar al modal
              callback(nuevoId)
            }
            else {
              this.isModalCita = false
              this.$swal.fire({
                title: 'Infomación',
                text: 'No tienes pases sificientes puedes hacer una recarga de 5 a un costo especial contacta a tu agente.',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
                backdrop: false
              });
            }
          })
          .catch(() => {
          })
          .finally(() => {
            //this.$refs.modalPaseMedico.reloadTable()


          });
      } else {
        this.especialidad = ''
        this.medico = ''
        this.beneficiado = ''
        this.$swal.fire({
          // position: 'top-end',
          title: 'Infomación',
          text: `Selecciona una especialidad, un médico y para quien será el pase.`,
          icon: 'warning',
          confirmButtonText: 'Cerrar',
          showCloseButton: false,
          // timer: 1500,
          backdrop: false,
        })
      }
    },
    async getColectivos() {
      this.$http.get(`colectivo/admin`)
        .then(response => {
          if (response.status === 200) {
            this.colectivos = response.data
          }
        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
    changeColectividad(value) {
      this.planesUnicos = {}
      this.idcolectividadSelect = value
      this.verOptDownloadCole = value !== null;
      if (value) {
        this.idagenteSelect = null
        this.NombreMem = null
      }
    },
    changeAgent(value) {
      this.idagenteSelect = value
      if (value) {
        this.idcolectividadSelect = null
        this.NombreMem = null
      }
    },
    async getMembresias() {


      this.$http.get(`membresia?qry=${this.NombreMem || null}&idAgent=${this.idagenteSelect || null}&Colectivo=${this.idcolectividadSelect || null}`)
        .then(response => {
          if (response.status === 200) {
            this.contratos = [...response.data];  // Copiar los datos para evitar referencias directas

            this.activas = this.contratos?.filter(item => item.Estatus === 'ACTIVO').length;
            this.suspendidas = this.contratos?.filter(item => item.Estatus === 'SUSPENDIDO').length;
            this.totalbajas = this.contratos?.filter(item => item.Estatus === 'BAJA').length;
            const conteo = {};

            this.contratos?.forEach(item => {
              if (item.Plan && item.Estatus === 'ACTIVO') {
                conteo[item.Plan] = (conteo[item.Plan] || 0) + 1;
              }
            });

            this.planesUnicos = Object.entries(conteo).map(([nombre, cantidad]) => ({
              nombre,
              cantidad
            }));
          }
        })
        .catch(() => {
        })
        .finally(() => {
        });

    },
    actualizaNumCitas(membresiaId) {
      this.$http.get(`Membresia/Numerocitas${this.MembresiaSelect.Id}`)
        .then(response => {
          if (response.status === 200) {
            const index = this.contratos.findIndex(item => item.Id === membresiaId);
            if (index !== -1) {
              this.contratos[index].NumCitas = response.data[0].NumCitas;
            }

            this.MembresiaSelect.NumCitas = response.data[0].NumCitas
            //this.MembresiaSelect.Estatus  = response.data[0].Estatus
          }
        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
    DescargaZip() {
      if (this.idcolectividadSelect) {
        var urltarjet = `${process.env.VUE_APP_FORMATOS}Tarjeta/Colectividad?guid=${this.idcolectividadSelect}`;
        var newTab = window.open(urltarjet);
        if (newTab) {
          newTab.focus();
        }
      }
    },
    Buscar() {
      this.getMembresias()
    },
    changeSearch() {
      this.idcolectividadSelect = null
      this.idagenteSelect = null
    },
    onActionSelected(action, item) {
      this.MembresiaSelect = { ...item }
      switch (action) {
        case 'BENEFICIADOS':
          this.dialogBeneficiados = true
          break;
        case 'PASES MEDICOS':
          this.dialogPases = true
          break;
        case 'HISTORIAL RECIBOS':
          this.dialogRecibos = true
          break;
        case 'OT':
          this.dialogRecibos = true
          break;
        case 'TARJETA DIGITAL':
          this.idSelect = item.Id
          this.verTarjeta()
          break;
        // case 'RENOVACION':
        //   this.idSelect = item.Id
        //     this.$router.push({ name: 'renov-membresia', params: { id: item.Id } })
        //   break;
        case 'REEMBOLSOS':
          this.dialogReembolso = true
          break;
        default:
          break;
      }
    },
    guardarReembolso(){
      this.reembolso.IdContrato = this.MembresiaSelect.Id
      this.loading = true
      this.$http.post(`reembolso`, this.reembolso)
          .then(response => {
            if (response.status === 200) {
              this.$swal.fire({
                position: 'top-end',
                title: 'Correcto',
                text: 'Reembolso registrado correctamente.',
                icon: 'success',
                confirmButtonText: 'Cerrar',
                showCloseButton: false,
                showConfirmButton: false,
                timer: 1500,
                backdrop: false
              })
              this.reembolso = {
                Folio: null,
                // IdTipoReembolso: null,
                // IdPaciente: null,
                FechaGasto: null,
                Monto: null
              }
              this.reloadReembolsos++
            } 
          })
          .catch(() => {

          }) .finally(() => {
            this.loading = false
          });
        // this.dialogReembolso = false
    },
    changetipoRee(value){
      this.reembolso.IdTipoReembolso = value
    }
  }
}
</script>

<style lang="scss" scoped></style>